import type { VoidFunctionComponent } from 'react';

import styles from './FileTree.module.less';

export type FileTreeNodeTextProps = {
  /**
   * The text to display.
   */
  text: string;
};

const FileTreeNodeText: VoidFunctionComponent<FileTreeNodeTextProps> = ({ text }) => (
  <span className={styles.treeViewNodeText}>
    {text}
  </span>
);

export default FileTreeNodeText;
